const subscriptionNames = [
    "AI Model Building",
    "Real-time Surveillance",
    "Product Pricing",
    "Manage Users"
    //Behavior Analytics
];

export default subscriptionNames;